import { createModel } from "@/util/ModelUtil";

export default class TicketModel {
  constructor(
    public id: number = 0,
    public title: string = "",
    public organizationName: string = "",
    public organizationId: number = 1,
    public status: string = "",
    public createdAt: string = "",
    public expiredAt: string = "",
    public startedAt: string = "",
    public updatedAt: string = "",
    public lectureList: Lecture[] = []
  ) {}

  public static create(ticket?: Ticket): TicketModel {
    return createModel<TicketModel>(TicketModel, ticket);
  }
}
